import { gql } from '@apollo/client';

export const GET_WORKSHIFT_WORKER = gql`
  query workshiftWorkerData($id: Int) {
    getWorkShiftPaymentOverviewData(id: $id) {
      created_at
      finished_at
      worker {
        uuid
        first_name
        last_name
        phone
        avatar_url
        roles {
          alias
        }
      }
      sum {
        tips
      }
    }
  }
`;
